import { render, staticRenderFns } from "./DataDisplay.vue?vue&type=template&id=eb2308b8&scoped=true"
import script from "./DataDisplay.vue?vue&type=script&lang=js"
export * from "./DataDisplay.vue?vue&type=script&lang=js"
import style0 from "./DataDisplay.vue?vue&type=style&index=0&id=eb2308b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2308b8",
  null
  
)

export default component.exports